import { getRouterBaseName } from "./utils/utils"

export const REMOTE_PATH = process.env.REACT_APP_REMOTE_PATH || "/"
export const ROUTER_BASENAME = getRouterBaseName()

export const COOKIE_LAYER_EXPIRES = 30